export var SelectModelModalType;
(function (SelectModelModalType) {
    SelectModelModalType["DEFAULT"] = "default";
    SelectModelModalType["COMPARISON"] = "comparison";
})(SelectModelModalType || (SelectModelModalType = {}));
export var SWITCHER_OPTIONS;
(function (SWITCHER_OPTIONS) {
    SWITCHER_OPTIONS["OPTION_BY_NAME"] = "option by name";
    SWITCHER_OPTIONS["OPTION_BY_TYPE"] = "option by type";
})(SWITCHER_OPTIONS || (SWITCHER_OPTIONS = {}));
export const SWITCHER_NAME = 'select-model-switcher';
export const STUDIO_REGEXP = /Studio/i;
export const SELECT_CATEGORY_DROPDOWN_ID = 'select-category-dropdown-id';
export const SELECT_MODEL_YEAR_DROPDOWN_ID = 'select-model-year-dropdown-id';
export const SELECT_MODEL_DROPDOWN_ID = 'select-model-dropdown-id';
export const MIN_SEARCH_LENGTH = 1;
export const HIDE_MODAL_ANIMATION_TIME = 150;
export const DROPDOWN_ACTIVE_PADDING_VALUE = '10px 12px';
export const PRODUCT_INDEX_ATTRIBUTE = 'productIndex';
export var DropdownListMaxHeight;
(function (DropdownListMaxHeight) {
    DropdownListMaxHeight["DESKTOP"] = "284px";
    DropdownListMaxHeight["TABLET"] = "318px";
    DropdownListMaxHeight["MOBILE"] = "159px";
})(DropdownListMaxHeight || (DropdownListMaxHeight = {}));
export const SELECT_MODEL_CACHE_TIMEOUT = 1000 * 60 * 30;
export const MODEL_NAME = '{model_name}';
